import { render, staticRenderFns } from "./UpdateViewBodyIndexModal.vue?vue&type=template&id=45e0104c"
import script from "./UpdateViewBodyIndexModal.vue?vue&type=script&lang=js"
export * from "./UpdateViewBodyIndexModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports